export default __webpack_public_path__ + "static/O0223-92b4b88c8cbd1806b36b3445c2ebf76f.png";